module.exports = {"title":"Neočekávaná chyba","action":"Prosím obnovte Gnosus aplikaci","button":"Obnovit"}